import React from 'react';
import {
  Box,
  ButtonIcon,
  Chip,
  Icon,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import moment from 'moment';

import { useInvertedLocalize } from '../../../../utils/localization';
import formatDuration from '../../utils/formatDuration';
import statusChipColor from '../../utils/statusChipColor';

import invertedMessages from './messages';

import './PageHeader.css';

function PageHeader({ reportData, currentStatus, onClose, globalDateFormat }) {
  const l = useInvertedLocalize(invertedMessages);
  const generatedAt = reportData?.completedAt
    ? moment
        .utc(reportData.completedAt)
        .local()
        .format(
          `${(globalDateFormat || 'MMM DD, YYYY').toUpperCase()} hh:mm:ss`
        )
    : null;

  const duration = reportData?.executionTimeMs
    ? formatDuration(reportData.executionTimeMs)
    : null;

  const isRunning = currentStatus === 'RUNNING';

  return (
    <Box className='PageHeader'>
      <Box className='PageHeader-titleGroup'>
        <Typography
          kind='h2'
          desktop='h2-d'
          mobile='h2-d'
          className='PageHeader-title'>
          {l('Pre-Launch Analytics')}
        </Typography>
        <Box className='PageHeader-subtitle'>
          <Box tag='span' className='PageHeader-campaignName'>
            {reportData?.campaignName || ''}
          </Box>
          {currentStatus && (
            <Chip
              kind='boldFilled'
              color={statusChipColor(currentStatus)}
              size='xSmall'
              label={currentStatus}
              isInteractionDisabled
              className='PageHeader-statusChip'
            />
          )}
          {!isRunning && generatedAt && (
            <>
              <Box tag='span' className='PageHeader-sep'>
                ·
              </Box>
              <Box tag='span' className='PageHeader-generated'>
                {l('Generated:')}
                {generatedAt}
              </Box>
            </>
          )}
          {!isRunning && duration && (
            <>
              <Box tag='span' className='PageHeader-sep'>
                ·
              </Box>
              <Box tag='span' className='PageHeader-duration'>
                {`${l('Duration:')} ${duration}`}
              </Box>
            </>
          )}
        </Box>
      </Box>

      <ButtonIcon
        kind='ghost'
        size='large'
        icon={<Icon kind='close' />}
        onClick={onClose}
        ariaLabel={l('close')}
        className='PageHeader-closeBtn'
      />
    </Box>
  );
}

PageHeader.propTypes = {
  reportData: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  currentStatus: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  globalDateFormat: PropTypes.string,
};

PageHeader.defaultProps = {
  reportData: null,
  currentStatus: '',
  globalDateFormat: '',
};

export default PageHeader;
